import { Tooltip } from '@mui/material';
import React, { FC, ReactElement } from 'react';

interface ICustomDisabledElementProps {
	message: string | null;
	children: ReactElement;
	placement?: any;
	hoverOnDisabled?: boolean;
}

export const CustomTooltipElement: FC<ICustomDisabledElementProps> = ({
	message,
	children,
	hoverOnDisabled,
	placement = 'top',
}) => {
	return (
		<Tooltip
			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: '#f5f5f9',
						color: 'rgba(0, 0, 0, 0.87)',
						fontSize: '12px',
						maxWidth: 250,
						textAlign: 'center',
						border: '1px solid #dadde9',
						'& .MuiTooltip-popper': { margin: 0 },
					},
				},
			}}
			PopperProps={{
				modifiers: [
					{
						name: 'offset',
						options: {
							offset: [0, -15],
						},
					},
				],
			}}
			title={message}
			placement={placement}
			disableHoverListener={hoverOnDisabled}
		>
			{children}
		</Tooltip>
	);
};
